export const mapSortValueToSortFields = (sort?: string) => {
  if (sort === 'popular') {
    return { sortByRating: 'desc' as const };
  }
  if (sort === 'new') {
    return { sortByCreatedAt: 'desc' as const };
  }
  return {};
};
